import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { calculateProductPrice } from 'src/app/helpers/CalculateProductPrice';
import { CompanyValues } from 'src/app/helpers/CompanyValues';
import { Product } from 'src/app/models/Product';
import { RouterService } from 'src/app/services/router-service.service';

@Component({
	selector: 'app-product-card',
	templateUrl: './product-card.component.html',
	styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {

	@Input() product! : Product;
	values = CompanyValues;
	@Input() loggedUserStoreId? : number | null;
	ariaLabel! : string;

	constructor(public routerService:RouterService,
				private numberPipe:DecimalPipe) {
	}

	ngOnInit() {
		this.product.priceAfterDiscount = calculateProductPrice(this.product);
		this.ariaLabel = this.product.title;
		if (this.product.category)
			this.ariaLabel += ", categoría "+ this.product.category.title;
		this.ariaLabel += ", precio " + this.numberPipe.transform(this.product.priceAfterDiscount, "1.2") + " pesos";
		if (this.product.priceAfterDiscount < this.product.amount) {
			this.ariaLabel += ", incluyendo descuento de "+ this.product.product_discount[0].amount + "%";
		}
	}
}
